import React from "react";
import { brandAssets } from "../data/offer";
const navItems = [{
  label: "Le contenu",
  href: "#contenu"
}, {
  label: "Les bonus",
  href: "#bonus"
}, {
  label: "Questions",
  href: "#faq"
}];
export function SiteHeader() {
  return <>
      <div className="bg-royal px-4 py-2 text-center" data-id="element-228" data-mp="1nm4wrlyqx3l6">
        <p className="font-display text-[13px] font-semibold text-white md:text-sm" data-id="element-229" data-mp="1injtfdo763si">
          Des moments de foi à partager en famille, une parabole à la fois.
        </p>
      </div>
      <header className="sticky top-0 z-40 border-b-2 border-sun/60 bg-ivory/95 backdrop-blur" data-id="element-230" data-mp="qx5k7ur4pfn6">
        <div className="mx-auto flex h-[68px] max-w-6xl items-center justify-between gap-3 px-4 md:px-5" data-id="element-231" data-mp="14w55qtjchef4">
          <a href="#top" className="flex items-center gap-2.5" data-id="element-232" data-mp="zwsmeirompha">
            <img src={brandAssets.logo} alt="Logo Petites Histoires, Grande Foi" className="h-12 w-12 shrink-0 object-contain" data-id="element-233" data-mp="zzomacn3bo8d" />
            <span className="font-display text-[15px] font-extrabold leading-[1.05] md:text-lg" data-id="element-234" data-mp="2bc8z7q076xal">
              <span className="block text-royal" data-id="element-235" data-mp="29jk8t4nluhfo">Petites Histoires,</span>
              <span className="block text-tangerine" data-id="element-236" data-mp="2ehlpxk1h06oi">Grande Foi</span>
            </span>
          </a>
          <nav aria-label="Navigation principale" className="flex items-center gap-6" data-id="element-237" data-mp="2jjb438jzp0gt">
            <ul className="hidden items-center gap-6 md:flex" data-id="element-238" data-mp="2og1htp8bnjz2">
              {navItems.map(item => <li key={item.href} data-id="element-239" data-mp="1qudo5c393fr8">
                  <a href={item.href} className="font-display text-base font-semibold text-royal transition-colors duration-150 hover:text-tangerine" data-id="element-240" data-mp="1qr7xvtivy7tx">
                    {item.label}
                  </a>
                </li>)}
            </ul>
            <a href="#offre" className="whitespace-nowrap rounded-full bg-tangerine px-4 pb-1.5 pt-2 font-display text-sm font-extrabold tracking-wide text-white shadow-[0_3px_0_#C4560A] transition-colors duration-150 hover:bg-tangerine-dark md:text-base" data-id="element-241" data-mp="182ui0wdxjlkz">
              <span className="sm:hidden" data-id="element-242" data-mp="1024zer99f1r7">L’OFFRE</span>
              <span className="hidden sm:inline" data-id="element-243" data-mp="101lt67sz21t0">DÉCOUVRIR LE MÉGA PACK</span>
            </a>
          </nav>
        </div>
      </header>
    </>;
}